import { graphql } from '@/gql';
import { get } from 'lodash';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSavedOrders = async (callerId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
    },
    query: graphql(`
      query GetSavedOrders($callerId: String!) {
        getSavedOrders(callerId: $callerId) {
          count
          rows {
            id
            service
            order
            orderId
            storeOrder {
              title
            }
          }
        }
      }
    `),
  });

  const savedDeliveryOrders = get(response, 'data.getSavedOrders.rows', []);

  return savedDeliveryOrders;
};
